{
  "loggingSetup": "Add Log Sources",
  "logSource": "Add a log source! Instructions on how to send your logs.",
  "askAdmin": "Please ask an admin to set up logging for your organization.",
  "documentation": "Documentation",
  "moreInfo": "Looking for more information? Check out our docs page!",
  "statusPage": "Status Page",
  "systemStatus": "Are we up or down? Check our system status.",
  "contactSupport": "Contact Support",
  "questionsOrSuggestions": "Have questions or suggestions? Let us know!",
  "chatWithUs": "Chat with us",
  "chatAndSupport": "Chat with us live or open a support ticket."
}
